import React, { useEffect, useState } from "react";
import { NavLink, Link } from "react-router-dom";
import HomeNavbarmenu from "../HomeFolder/HomeNavbarmenu";
import HomeSideNavbar from "../HomeFolder/HomeSideNavbar";
import AOS from "aos";
import "aos/dist/aos.css";
import "./CultureContent.css";

function CultureContent() {
  return (
    <>
      <div className="home-sidenavbar-holder">
        <HomeSideNavbar />
      </div>
      <div className="navbar-holder">
        <HomeNavbarmenu />
      </div>
      <div className="academies-banner-container">
        <ul className="breadcrumbs">
          <li className="breadcrumbs-item">
            <NavLink
              activeClassName="is-active"
              className="breadcrumbs-links"
              to="/Home"
            >
              L&TT Home
            </NavLink>
            <span>/</span>
          </li>
          <li className="breadcrumbs-item">
            <NavLink
              activeClassName="is-active"
              className="breadcrumbs-links"
              to="/Culture-Insights"
            >
              Culture & Insights
            </NavLink>
          </li>
        </ul>
      </div>
      <h2 className="under-construction">Under Construction</h2>
    </>
  );
}

export default CultureContent;
